/**
      *********************************************************
      Description: Right sidebar.
      Required props:  options,items. Items to generate icons and names.
      limitations    : N/A
      *********************************************************
**/
import { Box, Paper, Tab, Tabs, Toolbar, Typography } from '@material-ui/core';
//import MenuItem from '@material-ui/core/MenuItem';
//Expansion Panels For Tree
import { deepPurple } from '@material-ui/core/colors';
// Menu Items and Grouping
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link, withRouter, useHistory, useLocation } from "react-router-dom";
//import useUnsavedChangesWarning from '../form/useUnsavedChangesWarning';
import { makeStyles } from '@material-ui/core/styles';
import { AddCircleOutline } from '@material-ui/icons';
import { getEnvVariable } from "../../../modules/environmentalList";
import { GetData } from "../../controls/helpers/requests";

const useStyles = makeStyles((theme) => ({
    listItem: {
        '&:hover': {
            backgroundColor: '#ede7f6',
            color: '#5e35b1',
            //backgroundColor: 'rgb(215 225 229)',
            // backdropFilter: 'blur(10px)',
            // border: '1px solid #00355f',
            // boxShadow: '0 1px 0px 0 #00355f, 0 0px 0px 0 #00355f',
            // borderRadius: '10px',
            // border: '2px solid #00355f',
            // borderRadius: '10px',  // Change the color and thickness as needed
        },
    },
    selected: {
        backgroundColor: '#ede7f6',
        color: '#5e35b1',
        //backgroundColor: 'rgb(215 225 229)',
        //     backdropFilter: 'blur(10px)',
        //     border: '1px solid #00355f',
        //   //  boxShadow: '0 0px 0px 0 #00355f, 0 0px 0px 0 #00355f',
        //     borderRadius: '10px',

    },
    hiddenIcon: {
        display: 'none',
    },
    parent: {
        '&:hover $hiddenIcon': {
            display: 'block',
        },
    },
    textWithSpace: {
        marginRight: '40px',
    },
}));

const drawerWidth = 200;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth - 50,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    purpleAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: deepPurple[500],
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(9.2) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px 0 0',
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(1) * 3,
    },
    last: {
        display: 'flex',
        position: 'fixed',
        bottom: '0px',
        backgroundColor: '#212529 !important',
        margin: '0px'
    },

});





const SidebarView = withStyles(styles)((props) => {
    const { options, components, defaults, order, type, children, rules, drawerOpen, handleTitle, classes, theme, width, ...otherProps } = props;
    const { text, icon, items, anchor, ...otherOptions } = options
    let Profile = localStorage.getItem('profile') && JSON.parse(localStorage.getItem('profile'))
    const open = useSelector(state => state.header && state.header.leftmenuDrawer ? state.header.leftmenuDrawer : false);
    const isTabView = useSelector(state => state.header && state.header.movebartoTop ? state.header.movebartoTop : 'N')
    
    const [sidebarItems, setSidebarItems] = React.useState([]);

    // Load sidebar menu data from localStorage or API — run once
    React.useEffect(() => {
        const menutabslist = localStorage.getItem('Menutabslist');
        if (menutabslist) {
            try {
                const menuData = JSON.parse(menutabslist);
                const sortedMenus = menuData.sort((a, b) => {
                    const orderA = a.orderNo || 999;
                    const orderB = b.orderNo || 999;
                    return orderA - orderB;
                });
                setSidebarItems(sortedMenus);
            } catch {
                setSidebarItems([]);
            }
            return;
        }

        // only attempt fetch when a logged-in profile exists (read inside effect)
        const profileLocal = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : null;
        if (profileLocal) {
            const url = getEnvVariable('System') + 'api/system/menus/UserMenu';
            GetData(url)
                .then((res) => {
                    if (res) {
                        localStorage.setItem('Menutabslist', JSON.stringify(res));
                        const sortedMenus = res.sort((a, b) => {
                            const orderA = a.orderNo || 999;
                            const orderB = b.orderNo || 999;
                            return orderA - orderB;
                        });
                        setSidebarItems(sortedMenus);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching sidebar menu data:", error);
                    setSidebarItems([]);
                });
        }
    }, []); // run once

    if (Profile && open && isTabView === 'N')
        return (
            <>
                <Drawer open={true}
                    variant="permanent"
                    anchor={anchor}
                    className={classNames(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: classNames({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                    {...otherOptions}
                >
                    <Toolbar />
                    { /* prefer list from localStorage; fallback to options.items */ }
                    <SidebarListView items={(sidebarItems && sidebarItems.length) ? sidebarItems : (items || [])} classes={classes} Profile={Profile} />
                </Drawer>
            </>
        );
    else return <div></div>
});



// const Popovers = (props) => {

//     const [anchorEl, setAnchorEl] = React.useState(null);

//     const handleClick = event => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleClose = () => {
//         setAnchorEl(null);
//     };

//     const open = Boolean(anchorEl);
//     const id = open ? 'simple-popover' : undefined;

//     let submodules = JSON.parse(localStorage.getItem('submodule')) || []


//     const CSSColorClasses = (style = '') => {
//         let module = getEnvVariable('ModuleKey')
//         switch (module) {
//             case 'AEPS':
//                 return 'rgba(0, 53, 95, 255)'
//             // case 'AMES':
//             //     return 'rgb(41,51,82) !important'
//             case 'WRS':
//                 return '#0076A5'
//             default:
//                 return '';
//         }
//     }

//     return (
//         <div>
//             {/* {props && props.moduleRegionAccess.find(element => element === 'Add') && <IconButton onClick={handleClick} title="Quick Links"><AddIcon /></IconButton>} */}
//             <IconButton onClick={handleClick} title="Quick Links" style={{ color: CSSColorClasses() }}><AddIcon /></IconButton>
//             <Popover
//                 id={id}
//                 open={open}
//                 anchorEl={anchorEl}
//                 onClose={handleClose}
//                 anchorOrigin={{
//                     vertical: 'bottom',
//                     horizontal: 'center',
//                 }}
//                 transformOrigin={{
//                     vertical: 'top',
//                     horizontal: 'center',
//                 }}
//             >
//                 {submodules && Array.isArray(submodules) && submodules.length > 0 && submodules.map(res => {
//                     if (getEnvVariable('AccessPortal') === 'E' && res.key && (hideForSubmodules(res.key))) {
//                         return null
//                     }
//                     else {
//                         return <Typography paragraph gutterBottom={true} className="m-3 " onClick={handleClose}>
//                             <Link to={`${res.link}/NEW`}> {`Apply for ${res.title}`}</Link>
//                         </Typography>
//                     }
//                 })}
//                 <Divider />
//             </Popover>
//         </div>
//     );
// }
/**
      *********************************************************
      Description: Wrapper for generating the menu or grouping items or having the tree layout.
      Required props:  items
      limitations    : N/A
      *********************************************************
**/
const Wrapper = (props) => {
    const { items, classes, Profile, canAdd = false } = props;

    const checkCondition = (item) => {
        if (item.isOAuth === 'Y') {
            return localStorage.getItem('OAuth') === 'Y';
        }
        else if (item.roles) {
            let roles = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')).roles : null;
            return roles && roles.length > 0 && Object.keys(roles).some(each => item.roles.includes(roles[each]));
        }
        return true;
    }

    return items && items.length > 0 && items.map(each => {
        const { type, key, id, ...otherProps } = each
        if (type === 'menu')
            if (checkCondition(each))
                return <MenuItem {...otherProps} key={key || id} Profile={Profile} canAdd={canAdd} />
        if (type === 'group')
            return <GroupItem {...otherProps} classes={classes} key={key || id} />
        if (type === 'tree')
            return <TreeItem {...otherProps} classes={classes} key={key || id} />
        if (type === 'recordmenu')
            return <RecordMenuView {...otherProps} classes={classes} key={key || id} />
        return null;
    })
}

/**
      *********************************************************
      Description: Generates list item.
      Required props:  N/A
      limitations    : N/A
      *********************************************************
**/
const handleNewClick = (event, link, history) => {
    event.stopPropagation(event);
    history.push(link + '/new')
}



export const MenuItem = withRouter(({ location, history, canAdd, ...listitem }) => {
    const classes = useStyles();
    const { link, handleTitle, reloadtab, newtab, newTab, isProfile, Profile, title, displayName } = listitem;
    
    let tempColor = {
        "style": {
            'color': listitem.colorHex || listitem.color || ''
        }
    }

    const handleTabClick = () => {
        if (newtab === 'Y' || newTab === 'Y') {
            window.open(link, '_blank');
        } else {
            history.push(link)
        }
    }

    const displayTitle = displayName || title;
    const iconName = listitem.materialIcon || listitem.materialicon;

    if (link) {
        const linkis = isProfile ? link + (Profile && Profile.modulePermissions && Profile.modulePermissions[0] && Profile.modulePermissions[0].companyId) : link;
        return (
            <Fragment>
                <Link to={linkis} className={classes.parent} target={newtab === 'Y' || newTab === 'Y' ? "_blank" : ""}>
                    <ListItem button onClick={() => handleTabClick()}
                        className={linkis === location.pathname ? classes.selected : classes.listItem}>
                        <ListItemIcon><Icon style={listitem.style || tempColor.style}>{iconName}</Icon></ListItemIcon>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <ListItemText primary={displayTitle} />
                            <div style={{ marginRight: '10px' }} />
                        </div>
                        {canAdd && <Link onClick={(event) => handleNewClick(event, listitem.link, history)} >
                            <ListItemIcon className={classes.hiddenIcon}><AddCircleOutline /></ListItemIcon></Link>}
                    </ListItem>
                </Link>
            </Fragment>
        )
    } else {
        return (
            <ListItem>
                <ListItemText key={displayTitle}><Typography variant="body2">{displayTitle}</Typography></ListItemText>
            </ListItem>
        )
    }
})
/**
      *********************************************************
      Description: Generates items.
      Required props:  N/A
      limitations    : N/A
      *********************************************************
**/
const GroupItem = (groupitems) => {
    return (
        <Fragment>
            <Divider />
            <List>
                <Wrapper {...groupitems.items} />
            </List>
            <Divider />
        </Fragment>
    )
}
/**
      *********************************************************
      Description: Generates items in the form of a tree with a expand collapse icon.
      Required props:  N/A
      limitations    : N/A
      *********************************************************
**/


const TreeItem = (treeitems) => {
    const { name, title, items, materialIcon, materialicon, lskey } = treeitems;
    const displayTitle = name || title;
    const displayIcon = materialIcon || materialicon;
    
    return (
        <Box style={{ marginTop: 10, marginLeft: 1 }}>
            <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 'bolder' }}>
                {displayTitle}
            </Typography>
            <Wrapper items={lskey ? JSON.parse(localStorage.getItem(lskey)) : items} />
            <Divider />
        </Box>
    )
}

const RecordMenuView = (treeitems) => {
    const { name, title, items, materialIcon, materialicon, lskey } = treeitems;
    return (
        <Wrapper items={lskey ? JSON.parse(localStorage.getItem(lskey)) : items} canAdd={true} />
    )
}

SidebarView.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withWidth()(withRouter(SidebarView));

// New: SidebarListView - renders provided JSON in list view (parents + child items)
const SidebarListView = (props) => {
    const { items, classes } = props;
    const history = useHistory();
    const location = useLocation();

    const handleNavigation = (item) => {
        if (!item) return;
        if (item.newtab === 'Y' || item.newTab === 'Y') {
            if (item.link) window.open(item.link, '_blank');
            return;
        }
        if (item.GetValforLocal) {
            const val = localStorage.getItem(item.GetValforLocal);
            const link = val ? `${item.link}${val}` : item.link;
            if (link) history.push(link);
            return;
        }
        if (item.FlowId) {
            const flowId = item.FlowId;
            const version = item?.Version || '1.0';
            let link = item.link || '/userprocessflows';
            if (!link.endsWith('/')) link = `${link}/`;
            link += flowId;
            if (version) link += `/${version}`;
            history.push(link);
            return;
        }
        if (item.link) history.push(item.link);
    };

    const checkCondition = (item) => {
        if (!item) return false;
        if (item.isOAuth === 'Y') return localStorage.getItem('OAuth') === 'Y';
        if (item.roles && item.roles.length > 0) {
            const user = localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : null;
            const userRoles = user && user.roles ? user.roles : null;
            if (!userRoles) return false;
            return item.roles.some(r => userRoles.includes(r));
        }
        return true;
    };

    // Build records similar to menutabs.getRecords()
    const records = React.useMemo(() => {
        const processFlows = localStorage.getItem('ProcessFlows')
            ? JSON.parse(localStorage.getItem('ProcessFlows'))
            : [];
        const submodules = localStorage.getItem('submodule')
            ? JSON.parse(localStorage.getItem('submodule'))
            : [];

        if (!processFlows || !processFlows.length) return [];

        if (!submodules || !submodules.length) return processFlows;

        return processFlows.map(record => {
            let categories = record.Category;
            if (!categories) return null;
            if (typeof categories === 'string') {
                categories = categories.split(',').map(s => s.trim());
            }
            const matchedSub = submodules.find(sub =>
                categories.some(cat =>
                    cat.toLowerCase() === (sub.key || '').toLowerCase()
                )
            );
            if (matchedSub) {
                return {
                    ...record,
                    DisplayName: getEnvVariable("AccessPortal") === 'E'
                        ? (matchedSub.displayName || matchedSub.title)
                        : (matchedSub.title || matchedSub.displayName),
                    Color: matchedSub.color || '',
                    MaterialIcon: matchedSub.materialicon || ''
                };
            }
            return null;
        }).filter(Boolean);
    }, []); // compute once

    if (!items || !Array.isArray(items) || items.length === 0) return null;

    return (
        <List>
            {items
                .sort((a, b) => (a.orderNo || 999) - (b.orderNo || 999))
                .map((menu) => {
                    if (!checkCondition(menu)) return null;
                    const title = menu.name || menu.title || menu.displayName;
                    const iconName = menu.materialIcon || menu.materialicon || menu.icon;
                    const isRecords = (menu.key === 'Records' || menu.type === 'recordmenu');

                    return (
                        <Fragment key={menu.id || title}>
                            <ListItem
                                button
                                onClick={() => { if (!menu.items || menu.items.length === 0) handleNavigation(menu); }}
                                className={menu.link === (location && location.pathname) ? classes.selected : classes.listItem}
                            >
                                <ListItemIcon>
                                    <Icon style={{ color: menu.colorHex || menu.color || '' }}>{iconName}</Icon>
                                </ListItemIcon>
                                <ListItemText primary={title} />
                            </ListItem>

                            {/* If menu is Records (no menu.items), render records list */}
                            {isRecords && records && records.length > 0 && (
                                <List component="div" disablePadding>
                                    {records.map((rec) => {
                                        if (!rec) return null;
                                        const recTitle = rec.DisplayName || rec.Name || rec.title || rec.FlowName;
                                        const recIcon = rec.MaterialIcon || 'description';
                                        return (
                                            <ListItem
                                                key={rec.FlowId || rec.id || recTitle}
                                                button
                                                onClick={() => handleNavigation(rec)}
                                                className={classes.listItem}
                                                style={{ paddingLeft: 32 }}
                                            >
                                                <ListItemIcon style={{ minWidth: 32 }}>
                                                    <Icon style={{ fontSize: 18, color: rec.Color || '#666' }}>{recIcon}</Icon>
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={recTitle}
                                                    primaryTypographyProps={{ variant: 'body2', style: { fontSize: '0.875rem' } }}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            )}

                            {/* Normal child items */}
                            {!isRecords && menu.items && Array.isArray(menu.items) && menu.items.length > 0 && (
                                <List component="div" disablePadding>
                                    {menu.items
                                        .sort((a, b) => (a.orderNo || 999) - (b.orderNo || 999))
                                        .map((item) => {
                                            if (!checkCondition(item)) return null;
                                            const itTitle = item.title || item.displayName || item.name;
                                            const itIcon = item.materialIcon || item.materialicon || item.icon;
                                            return (
                                                <ListItem
                                                    key={item.id || itTitle}
                                                    button
                                                    onClick={() => handleNavigation(item)}
                                                    className={item.link === (location && location.pathname) ? classes.selected : classes.listItem}
                                                    style={{ paddingLeft: 32 }}
                                                >
                                                    <ListItemIcon style={{ minWidth: 32 }}>
                                                        <Icon style={{ fontSize: 18, color: item.colorHex || item.color || '' }}>{itIcon}</Icon>
                                                    </ListItemIcon>
                                                    <ListItemText primary={itTitle} primaryTypographyProps={{ variant: 'body2', style: { fontSize: '0.875rem' } }} />
                                                </ListItem>
                                            );
                                        })}
                                </List>
                            )}
                        </Fragment>
                    );
                })}
        </List>
    );
};

